import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaSave, FaArrowLeft, FaTicketAlt } from "react-icons/fa";
import { toast } from "react-toastify";
import { couponRecord, updateCoupon, clearState } from "../../redux/Slices/CouponsSlice";

const EditCoupon = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    code: "",
    discount_type: "percentage",
    discount_value: "",
    starts_at: "",
    ends_at: "",
    status: 1,
    usage_limit: "",
  });

  const [startFocused, setStartFocused] = useState(false);
  const [endFocused, setEndFocused] = useState(false);

  const { record, isLoading, error, success } = useSelector((state) => state.coupons);

  useEffect(() => {
    dispatch(clearState());
    dispatch(couponRecord(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (record) {
      setFormData({
        code: record.code || "",
        discount_type: record.discount_type || "percentage",
        discount_value: record.discount_value || "",
        starts_at: record.starts_at ? record.starts_at.split('T')[0] : "",
        ends_at: record.ends_at ? record.ends_at.split('T')[0] : "",
        status: record.status === "active" ? 1 : (record.status === "inactive" ? 0 : record.status),
        usage_limit: record.usage_limit || "",
      });
    }
  }, [record]);

  useEffect(() => {
    if (success) {
      toast.success(success || "تم تحديث الكوبون بنجاح");
      dispatch(clearState());
      navigate("/coupons");
    }
    if (error) {
      toast.error(typeof error === 'string' ? error : "فشل في تحديث الكوبون");
      dispatch(clearState());
    }
  }, [success, error, dispatch, navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let cleanValue = value;
    if (["discount_value", "usage_limit"].includes(name)) {
      cleanValue = value.replace(/-/g, "");
      const numValue = parseFloat(cleanValue);
      if (numValue < 0) {
        return;
      }
    }
    setFormData((prev) => ({ ...prev, [name]: cleanValue }));
  };

  // BUG-01 fix: منع خصم النسبة المئوية فوق 100% وإلزام تاريخ الانتهاء
  const validateCoupon = () => {
    const value = parseFloat(formData.discount_value);

    if (isNaN(value) || value <= 0) {
      toast.error("قيمة الخصم يجب أن تكون رقماً أكبر من صفر");
      return false;
    }

    if (formData.discount_type === "percentage" && value > 100) {
      toast.error("نسبة الخصم لا يمكن أن تتجاوز 100%");
      return false;
    }

    const usageLimitVal = parseFloat(formData.usage_limit);
    if (formData.usage_limit !== "" && formData.usage_limit !== null && formData.usage_limit !== undefined) {
      if (isNaN(usageLimitVal) || usageLimitVal <= 0) {
        toast.error("حد الاستخدام يجب أن يكون رقماً أكبر من صفر");
        return false;
      }
    }

    if (!formData.ends_at) {
      toast.error("تاريخ انتهاء الصلاحية مطلوب");
      return false;
    }

    if (formData.starts_at && formData.ends_at && formData.ends_at < formData.starts_at) {
      toast.error("تاريخ الانتهاء يجب أن يكون بعد تاريخ البدء");
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateCoupon()) return;
    dispatch(updateCoupon({ id, formData }));
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--warning-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(251, 191, 36, 0.15)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  if (isLoading && !record) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">جاري التحميل...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid" style={{ direction: "rtl", padding: "4px 0" }}>
      <style>{`
        .coup-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .coup-custom-select:focus {
          border-color: var(--warning-color) !important;
          box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.15) !important;
        }
        .coup-custom-date {
          width: 100% !important;
          padding: 10px 14px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          color: #0f172a !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .coup-custom-date:focus {
          border-color: var(--warning-color) !important;
          box-shadow: 0 0 0 3px rgba(251, 191, 36, 0.15) !important;
        }
        .coup-custom-date.empty {
          color: #94a3b8 !important;
        }
      `}</style>

      {/* ── Header ─────────────────────────────────────── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
        <div>
          <h4 style={{ margin: 0, fontWeight: 800, color: "#0f172a", fontSize: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <FaTicketAlt style={{ color: "var(--gray-color)" }} /> تعديل الكوبون
          </h4>
          <p style={{ margin: "2px 0 0", color: "#64748b", fontSize: 13 }}>تعديل كود الخصم والقيمة وتواريخ الصلاحية للكوبون الحالي</p>
        </div>
        <Link to="/coupons" style={{ textDecoration: "none" }}>
          <button style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 18px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 13 }}>
            <FaArrowLeft size={11} /> العودة
          </button>
        </Link>
      </div>

      <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "24px", boxShadow: "0 1px 4px rgba(0,0,0,.04)" }}>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>كود الكوبون *</label>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="SAVE20"
                required
              />
            </div>

            <div>
              <label style={labelStyle}>نوع الخصم *</label>
              <select
                className="coup-custom-select"
                name="discount_type"
                value={formData.discount_type}
                onChange={handleInputChange}
                required
              >
                <option value="percentage">نسبة مئوية (%)</option>
                <option value="fixed">قيمة ثابتة (ج.م)</option>
              </select>
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>القيمة *</label>
              <input
                type="number"
                name="discount_value"
                value={formData.discount_value}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="أدخل قيمة الخصم..."
                required
                min="0"
                max={formData.discount_type === "percentage" ? "100" : undefined}
                step="0.01"
              />
            </div>

            <div>
              <label style={labelStyle}>حد الاستخدام (اختياري)</label>
              <input
                type="number"
                name="usage_limit"
                value={formData.usage_limit}
                onChange={handleInputChange}
                style={inputStyle}
                onFocus={focusHandler}
                onBlur={blurHandler}
                placeholder="عدد مرات الاستخدام الأقصى..."
                min="1"
              />
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 20 }}>
            <div>
              <label style={labelStyle}>تاريخ البدء</label>
              <input
                type={startFocused || formData.starts_at ? "date" : "text"}
                name="starts_at"
                placeholder="اختر تاريخ بدء التفعيل"
                value={formData.starts_at}
                onChange={handleInputChange}
                onFocus={() => setStartFocused(true)}
                onBlur={() => setStartFocused(false)}
                className={`coup-custom-date${!formData.starts_at ? " empty" : ""}`}
              />
            </div>

            <div>
              <label style={labelStyle}>تاريخ الانتهاء *</label>
              <input
                type={endFocused || formData.ends_at ? "date" : "text"}
                name="ends_at"
                placeholder="اختر تاريخ انتهاء الصلاحية"
                value={formData.ends_at}
                onChange={handleInputChange}
                onFocus={() => setEndFocused(true)}
                onBlur={() => setEndFocused(false)}
                required
                className={`coup-custom-date${!formData.ends_at ? " empty" : ""}`}
              />
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label style={labelStyle}>الحالة *</label>
            <select
              className="coup-custom-select"
              name="status"
              value={formData.status}
              onChange={handleInputChange}
              required
            >
              <option value={1}>🟢 مفعل</option>
              <option value={0}>🔴 غير مفعل</option>
            </select>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button
              type="button"
              onClick={() => navigate("/coupons")}
              style={{ padding: "10px 20px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", color: "#475569", fontWeight: 600, cursor: "pointer", fontSize: 14 }}
            >
              إلغاء
            </button>
            <button
              type="submit"
              disabled={isLoading}
              style={{
                padding: "10px 28px",
                borderRadius: 10,
                border: "none",
                background: isLoading ? "var(--warning-color)" : "linear-gradient(135deg,#f59e0b,var(--warning-color))",
                color: "#fff",
                fontWeight: 700,
                cursor: isLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontSize: 14
              }}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm" />
                  جاري الحفظ...
                </>
              ) : (
                <>
                  <FaSave size={12} />
                  حفظ التعديلات
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCoupon;
